import React, { ComponentType, ReactNode, createContext } from 'react'

const DataProviderContext = createContext<undefined>(undefined)

interface Props {
  Provider?: ComponentType<{ children: ReactNode }>
  children: ReactNode
}

export const DataProvider: React.FC<Props> = ({ Provider, children }) => {
  return (
    <DataProviderContext.Provider value={undefined}>
      {Provider ? <Provider>{children}</Provider> : children}
    </DataProviderContext.Provider>
  )
}
